import { HPAScalingPolicyType } from '@cast/types';

import { ScalingPolicyTypeItem } from './ScalingPolicyTypeItem';

import { Box } from '@cast/design-system';

type RawPolicy = {
  type: HPAScalingPolicyType;
  value: number;
  periodSeconds: number;
};

const POLICY_TYPES = [
  HPAScalingPolicyType.PODS_SCALING_POLICY,
  HPAScalingPolicyType.PERCENT_SCALING_POLICY,
];

type ScalingPoliciesSubsectionProps = {
  titleSuffix: string;
  prevPolicies?: RawPolicy[];
  currPolicies?: RawPolicy[];
};

export const ScalingPoliciesSubsection = ({
  titleSuffix,
  prevPolicies,
  currPolicies,
}: ScalingPoliciesSubsectionProps) => (
  <Box
    display="grid"
    gridTemplateColumns="repeat(2, 1fr)"
    columnGap={100}
    width="100%"
  >
    {POLICY_TYPES.map((type) => (
      <ScalingPolicyTypeItem
        key={type}
        type={type}
        titleSuffix={titleSuffix}
        prev={prevPolicies?.find((p) => p.type === type)}
        curr={currPolicies?.find((p) => p.type === type)}
      />
    ))}
  </Box>
);
